<template>
  <div class="main-box">
    <div class="main-box-tab">
      <i class="el-icon-arrow-left" @click="previous"></i>
      <div
        ref="tabList"
        class="main-box-tab-content"
        :class="isBorderShow ? 'tab-content-border' : ''"
      >
        <div class="main-box-tab-roll">
          <div
            v-for="(item, index) in tabList"
            :key="index"
            @click.stop="clickTab(index)"
          >
            <div
              v-if="model == 1"
              class="tab-item1"
              :class="{ 'tab-item-active1': activeIndex === index }"
            >
              <div class="tab-item1-title">{{ item.categoryName }}</div>
              <div class="flex">
                <div class="tab-item1-left">
                  <div class="tab-item1-left-text">成交金额</div>
                  <div class="tab-item1-left-amount-box">
                    <span class="tab-item1-left-amount">{{
                      item.winTotalPrice
                    }}</span>
                    <span class="tab-item1-left-unit">元</span>
                  </div>
                </div>
                <div class="right">
                  <el-progress
                    type="circle"
                    :width="70"
                    :stroke-width="12"
                    :percentage="item.rate"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <i class="el-icon-arrow-right" @click="next"></i>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ScrollTab',
  props: {
    tabList: {
      required: true,
      type: Array
    },
    // 单个tab样式可以通过此字段，单独处理
    model: {
      type: Number,
      default: 1
    },
    isBorderShow: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      moveX: 0,
      count: 1,
      unoccupied: 0,
      tabListCount: 0,
      differ: 0,
      activeIndex: 0
    }
  },
  watch: {
    tabList: {
      handler() {
        this.$nextTick(() => {
          const tabList = this.$refs.tabList
          let getStyle = ''
          if (tabList.children[0].children[0]) {
            getStyle = getComputedStyle(tabList.children[0].children[0], null)
          } else {
            return
          }
          const marginLeft = parseFloat(
            getStyle.marginLeft.substr(0, getStyle.marginLeft.length - 2)
          )
          const marginRight = parseFloat(
            getStyle.marginRight.substr(0, getStyle.marginRight.length - 2)
          )
          this.width =
            marginLeft +
            marginRight +
            tabList.children[0].children[0].offsetWidth
          this.unoccupied = tabList.offsetWidth % this.width
          this.differ = this.width - this.unoccupied
          this.unoccupied = this.differ < 10 ? this.width : this.unoccupied
          this.tabListCount = parseInt(tabList.offsetWidth / this.width)
        })
      },
      deep: true
    },

    activeIndex(val) {
      const len = this.tabList.length
      // 如有重复数据退出后续函数执行
      for (let i = 0; i < len; i++) {
        if (i === val) {
          this.$nextTick(() => {
            this.translateX(
              (i + 1 - this.tabListCount) * this.width - this.unoccupied
            )
          })
          return
        }
      }
      this.$nextTick(() => {
        // (总共有多少个tab - 未偏移时可见的元素个数) * 单个tab标签元素长度 - 被遮挡tab元素的可见部分的宽度
        this.translateX(
          (this.tabList.length - this.tabListCount) * this.width -
            this.unoccupied
        )
      })
    }
  },
  mounted() {},
  methods: {
    /**
     * 切换tab标签页
     **/
    clickTab(index) {
      if (this.activeIndex !== index) {
        this.activeIndex = index
      }
      this.$emit('tabChange', index)
    },

    /**
     * 往右偏移
     **/
    next() {
      // scrollWidth获取不准确
      // 使用this.width * this.tabList.length计算出总长度
      const totalWidth = this.width * this.tabList.length

      this.$nextTick(() => {
        const dom = this.$refs.tabList

        // 可视区域 < 滚动区域（滚动区域大于可视区域才可以移动）
        // 移动距离 + 可视区域 = 滚动区域的宽度（上一次的宽度，当点击时才是实际宽度）< 滚动区域
        if (
          dom.clientWidth < totalWidth &&
          this.moveX + dom.clientWidth < totalWidth
        ) {
          const x = this.width - this.unoccupied
          // this.moveX为0减去空余空间的宽度
          this.moveX += this.moveX ? this.width : x || this.width

          if (this.moveX + dom.clientWidth > totalWidth) {
            this.moveX = this.moveX - this.width
          }

          this.translateX(this.moveX)
        }
      })
    },

    /**
     * 往左偏移
     **/
    previous() {
      if (this.moveX > 0) {
        this.moveX -= this.width
        this.translateX(this.moveX)
      }
    },

    /**
     * 开始移动dom
     **/
    translateX(x) {
      this.moveX = x < 0 ? 0 : x
      this.$refs.tabList.children[0].style.transform = `translateX(-${this.moveX}px)`
    }
  }
}
</script>

<style lang="scss" scoped>
.main-box {
  padding: 10px 20px 20px 20px;
  .main-box-tab {
    position: relative;
    padding: 10px 0;
    overflow: hidden;
    display: flex;
    align-items: center;
    & > i {
      cursor: pointer;
    }
    .main-box-tab-content {
      overflow: hidden;
      margin: 0 15px;
      .main-box-tab-roll {
        transition: transform 0.5s;
        display: flex;
        align-items: center;
      }
    }
    .tab-content-border {
      border-bottom: 1px solid $dividing-color;
    }
    .tab-item1 {
      padding: 15px;
      opacity: 0.7;
      cursor: pointer;
      .tab-item1-title {
        color: $text-color;
        font-size: 16px;
        @include text-bold;
        margin-bottom: 5px;
      }
      .tab-item1-left {
        margin-right: 10px;
        flex: 1;
        .tab-item1-left-text {
          font-size: 14px;
          color: $third-text-color;
          white-space: nowrap;
        }
        .tab-item1-left-amount-box {
          white-space: nowrap;
          .tab-item1-left-amount {
            font-size: 16px;
            color: $third-text-color;
            margin-top: 5px;
            @include text-bold;
          }
          .tab-item1-left-unit {
            font-size: 14px;
            color: $second-text-color;
            margin-left: 5px;
          }
        }
      }
    }
    .tab-item-active1 {
      border-bottom: 2px solid $primary-color;
      opacity: 1;
      .tab-item1-title {
        color: $primary-color;
      }
      .tab-item1-left {
        .tab-item1-left-amount {
          color: $text-color !important;
        }
      }
    }
  }
}
</style>
